import { RepositoryContract } from "@shared/services/api/abstracts/Repository";
import { AxiosError } from "axios";
import { t } from "../internationalization";

/**
 * Global API service that wraps specific axios behaviour into the application
 * so we can leverage auto assigning and refreshing JWTs and other tasks.
 * @deprecated This is no longer necessary as we deploy a different mechanism to have axios behaviour by nature on Repositories. @see https://github.com/showpass/showpass-frontend/pull/2269
 */
export function repo<T extends RepositoryContract>(
  RepositoryConstructor: new () => T
): T {
  return new RepositoryConstructor();
}

/** TODO current usage within catch block add toast("error", t("Error"), getAxiosErrorMessage(error));
 * https://showpass.atlassian.net/browse/SPW-10702
 * add generic error handling (5XX status codes) */
export function getAxiosErrorMessage(error: AxiosError): string {
  // if error message exist return message
  if (error?.response && error.response.data.detail)
    return error.response.data.detail;

  // if no error message in error object, match the code and return message
  switch (error.response?.status) {
    case 500:
      return t(
        "Whoops, an unexpected error has occurred. If the problem persists please contact us! (Error Code: 500)",
        { ns: "common" }
      );
    default:
      return t(
        "Something broke, and we are not sure what happened. Please try again - if the problem persists please contact us.",
        { ns: "common" }
      );
  }
}
